export default __webpack_public_path__ + "static/media/3.9f26cedf.svg";